import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Tool from "./tool";

const StyledToolGroup = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 5px;
`;

const ToolGroup = ({ auth, tools = [], data, ...rest }) => {
  return (
    <StyledToolGroup {...rest}>
      {tools.map((tool) => (
        <Tool
          key={tool.type}
          auth={auth}
          type={tool.type}
          size={tool.size}
          title={tool.title}
          titlePosition={tool.titlePosition}
          onClick={tool.onClick}
          data={data}
        />
      ))}
    </StyledToolGroup>
  );
};

ToolGroup.propTypes = {
  tools: PropTypes.arrayOf(PropTypes.object),
};

export default ToolGroup;
